export default __webpack_public_path__ + "static/media/fund-check.c142c5dd.png";